export const lmFieldLookupClickFunction = (
  event: any,
  lookup: SohoLookupStatic,
  clickArguments: any) => {

  if (!clickArguments) {
    return;
  }

  const listFieldLookupClickedEvent: LMListFieldLookupClickedEvent = {
    dataView:      clickArguments.rowData,
    selectListUrl: clickArguments.column.displayField.selectListUrl,
    lookup,
    sourceField:   clickArguments.column.displayField.selectFieldId,
    lplFieldInfo:  clickArguments.column.displayField.lplFieldInfo,
  };

  const listGridComponent = clickArguments.grid.settings.userObject();
  listGridComponent.listFieldLookupClicked.emit(listFieldLookupClickedEvent);
};
